import { render } from "./ExplorationPage.vue?vue&type=template&id=49278471&scoped=true"
import script from "./ExplorationPage.vue?vue&type=script&lang=js"
export * from "./ExplorationPage.vue?vue&type=script&lang=js"

import "./ExplorationPage.vue?vue&type=style&index=0&id=49278471&lang=css"
import "./ExplorationPage.vue?vue&type=style&index=1&id=49278471&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49278471"]])

export default __exports__